import  { useState } from 'react';
import { Box } from '@mui/material';
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Navbar from '../../../Navbar';
import OrdenesCompra from './OrdenesCompra';
import Requerimientosinternos from './Requerimientosinternos';

export default function Tablistado() {
    const [opcion, setOpcion] = useState("ordenes")
    const [tab, setTabs] = useState(true)
    const sector = Number(localStorage.getItem('sector'));
    const handleChange = (event, newValue) => {
        setOpcion(newValue);
    };

    return (
        <div>
            <Navbar />
            <Box sx={{ borderBottom: 1, borderColor: "divider", marginTop: 1 }}>
                {sector === 4   ?
                    <Tabs
                        value={opcion}
                        onChange={handleChange}
                        textColor="primary"
                        indicatorColor="primary"
                        aria-label="Ordenes compra"
                        variant="fullWidth"
                    >
                        <Tab value="ordenes" label="Ordenes compra" />
                        <Tab value="requerimientos" label="Requerimientos internos" />
                    </Tabs>
                    :
                    <OrdenesCompra tab={setTabs} />}
            </Box>
            {sector === 4 && opcion === "requerimientos" ? <Requerimientosinternos tab={setTabs} /> : null}
            {sector === 4 && opcion === "ordenes" ? <OrdenesCompra tab={setTabs} /> : null}
        </div>
    )
}
